import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import prod1 from "../../images/cool.png";
import prod2 from "../../images/substance.png";
import prod4 from "../../images/dry.png";
import {Container } from "react-bootstrap";
import "./ExploreProducts.css";


import ProcessedProducts from "./ProcessedProducts";
import SecondaryNavbar from "../SecondaryNavbar/SecondaryNavbar";

const ExploreProducts = () => {
   
  const navData = [{to:"/onMarketplace", link:"For Buyers"},
  {to:"/onMarketplaceSell", link:"For Sellers"},
  // {to:"/onMarketplaceRFQ", link:"RFQ"}
]
  const[rawProduct,setRawProduct] = useState(true);
  const[semiProduct,setSemiProduct] = useState(false);
  const[proccessedProduct,setproccessedproduct] = useState(false);
  const userType = ["FOOD-PROCESSOR"]
  const rawProductHandler =() =>{
    setRawProduct(true);
    setSemiProduct(false);
    setproccessedproduct(false);
  }

  const semiProductHandler =() =>{
    setSemiProduct(true);
    setRawProduct(false);
    setproccessedproduct(false);
  }
  const processedProductHandler =() =>{
    setproccessedproduct(true);
    setRawProduct(false);
    setSemiProduct(false);
  }

  return (
    <>
      <SecondaryNavbar props={navData}/>
      <div>
        <div className="serviceContainer ExploreBannerContainer" id="ExploreBannerContainer">
          <div className="gridSection">
            <h1 className="container-title mb-2 text-white">
              Ensured Quality | Tracebility | Provenance
            </h1>
            <p className="container-para text-white">
              Ensure food saftey across globe
            </p>

            <Grid
              container
              justifyContent="center"
              alignItems="center"
              spacing={2}
              direction="row"
            >
              <Grid
                id="complementaryServices_link"
                className="hoverEffect"
                item
                md={4}
                sm={4}
                xs={6}
              >
                <a onClick={rawProductHandler} href="#Raw-Products">
                  <img src={prod2} alt="" />
                  <h4>
                    Raw <br className="d-none d-md-block"></br>Products
                  </h4>
                </a>
              </Grid>

              <Grid
                id="complementaryServices_link"
                className="hoverEffect"
                item
                md={4}
                sm={4}
                xs={6}
              >
                <a onClick={semiProductHandler} href="#Semi-Processed-Products">
                  <img src={prod4} alt="" />
                  <h4>
                    Semi Processed <br className="d-none d-md-block"></br>{" "}
                    Products
                  </h4>
                </a>
              </Grid>
              <Grid
                id="coreServices_link"
                className="hoverEffect"
                item
                md={4}
                sm={4}
                xs={6}
              >
                <a onClick={processedProductHandler} href="#Processed-Products">
                  <img src={prod1} alt="" />
                  <h4>
                    Processed <br className="d-none d-md-block"></br>Products
                  </h4>
                </a>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <div className="explore-product-wrapper">
        <Container>
          <div className=" ">
            {/* Raw-Products */}
          {rawProduct === true &&  <div id="tendersContainer" className="container-fluid">
              <h3 id="Raw-Products" className="container-title  ">
                Raw Products
              </h3>
              <ProcessedProducts  quote="true"  type="RAW-PRODUCTS" userType = {userType} />
            </div>}
            {/* Semi-Processed-Products */}
            {semiProduct ===true && <div id="tendersContainer" className="container-fluid">
              <h3 id="Semi-Processed-Products" className="container-title">
                {" "}
                Semi Processed Products
              </h3>
              <ProcessedProducts quote="true"  type="SEMI-PROCESSED"  userType =  {userType}/>
            </div>}
            {/* Processed-Products */}
            {proccessedProduct && <div id="tendersContainer" className="container-fluid">
              <h3 id="Processed-Products" className="container-title  ">
                Processed Products
              </h3>
              <ProcessedProducts quote="true" type="PROCESSED-PRODUCTS" userType = {userType}/>
            </div>}
          </div>
        </Container>
      </div>
    </>
  );
};

export default ExploreProducts;
